import "./styles/styles.scss";
import Achievement from "./components/Achievement";
import Member from "./components/Member";
import { useState } from "react";
import Publication from "./components/Publication";
import achivements from './achievements.json'
import members from './members.json'
import publications from './publications.json'
import Prof from "./components/Prof";
import Slider from "react-slick";
import Moments from "./components/Moments";

function App() {
	const [index, setIndex] = useState(0);
	return (
		<div className="App">
			<div className="background"></div>
			<section id="home">
				<nav className="navbar">
					<div className="nav-brand">
						{/* <div className="brand-1">img</div>
						<div className="brand-2">Group</div> */}
						<img src="/images/logo_no_bg.png" alt="cdos-logo" />
					</div>
					<div className="nav-links">
						<a href="#home" className="nav-link">
							Home
						</a>
						<a href="#achievements" className="nav-link">
							Achievements
						</a>
						<a href="#members" className="nav-link">
							Members
						</a>
						<a href="#publications" className="nav-link">
							Publications
						</a>
					</div>
					<div className="nav-icons"></div>
				</nav>
				<div className="home-page">
					<div className="home-heading">
						<span className="span">Engineering &#8628;</span>
						<span className="span">
							<span className="tagline">
								Systematically Shaping the future
							</span>
							<span className="main"> Tomorrow's </span>
						</span>
						<span className="span">Systems, Today</span>
					</div>
					<div className="home-sub">
						<a href="#members" className="meet-members">
							Meet our members &#8599;
						</a>
					</div>
				</div>
			</section>
			{/* <section id="prof-home">
				<br />
				<div className="title">
					About us
				</div>
				<Prof />
			</section> */}
			{/* <section id="achievements">
				<div className="title">Recent Achievements</div>
				<div className="achieve-slide">
					<div className="left"></div>
					<Achievement {...achivements[index]} />
					<div className="right">
						{achivements.map((value, idx) => {
							return (
								<span
									className="achivement-index"
									onClick={() => setIndex(idx)}
								>
									{index == idx ? <>&#9737;</> : <>&#9900;</>}
								</span>
							);
						})}
					</div>
				</div>
			</section> */}
			<section id="members">
				<div className="title">Members</div>
				<div className="credits">
					{members.map((member, index) => {
						return <Member id={"member-" + index} {...member} />;
					})}
				</div>
			</section>
			<section id="publications">
				<div className="title">Publications</div>
				{publications.map((publication, index) => {
					return <Publication id={"publication-" + index} {...publication} />;
				})}
			</section>
			<section id="moments">
				<div className="title">Moments</div>
				{/* {publications.map((publication) => {
					return <Publication {...publication} />;
				})} */}
				<Moments />
			</section>
			<footer id="footer">
				<div className="main">
					CDOS Group
				</div>
				<br />
				<a href="https://www.cse.iitk.ac.in/">Department of Computer Science and Engineering</a>
				<br />
				<br />
				<a href="https://www.cse.iitk.ac.in/">IIT Kanpur</a>
			</footer>
		</div>
	);
}

export default App;
